module.exports = __webpack_public_path__ + "static/img/deportes_11.60e8330c.jpeg";